/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Girl from '../../assets/login/girl.svg';
import X from '../../assets/login/x.svg';
import {
  resetPassword, closeModal, clearPasswordStatuses, clearFullPasswordState, switchModal,
} from '../../actions';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmPass: '',
      newPass: '',
      blankPassError: null,
      blankConfirmError: null,
      matchError: null,
    };
  }

  componentDidMount() {
    this.props.clearPasswordStatuses();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.passwordResetSuccess && this.props.passwordResetSuccess) {
      this.props.switchModal('Success', 'reset');
    }
  }

  componentWillUnmount() {
    this.props.clearFullPasswordState();
  }

  resetPassword = () => {
    this.props.clearPasswordStatuses();
    this.setState((prevState) => {
      return {
        blankPassError: prevState.newPass === '',
        blankConfirmError: prevState.confirmPass === '',
        matchError: prevState.newPass !== prevState.confirmPass,
      };
    }, () => {
      if (
        this.state.newPass !== ''
      && this.state.confirmPass !== ''
      && this.state.newPass === this.state.confirmPass
      ) {
        this.props.resetPassword(this.props.hash, this.state.newPass);
      }
    });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    return (
      <div className="modal">
        <img className="x-icon" onClick={this.props.closeModal} src={X} alt="x" />
        <div className="sign-in-container">
          <img src={Girl} alt="person" />
          <div className="sign-in-body">
            <h2 className="sign-in-header" style={{ marginTop: '6vw', marginBottom: '2vw' }}>
              Reset Password
            </h2>
            <p className="sign-in-text">This will reset the password for the account associated with <b>{this.props.email}</b>.</p>
            <div className="form-container">
              <div className="sign-in-form-row">
                <label htmlFor="newPass" className="label-style">New Password</label>
                {this.state.blankPassError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
                <input type="password" name="newPass" className="sign-in-form-input" autoComplete="off" value={this.state.newPass} onChange={this.handleChange} />
              </div>
              <div className="sign-in-form-row">
                <label htmlFor="confirmPass" className="label-style">Confirm Password</label>
                {this.state.blankConfirmError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
                {this.state.matchError ? <p className="modal-form-error">These passwords do not match</p> : null}
                <input type="password" name="confirmPass" className="sign-in-form-input" autoComplete="off" value={this.state.confirmPass} onChange={this.handleChange} />
              </div>
              {this.props.resetError
                ? <p className="signin-error">There was an error resetting your password.</p>
                : null}
              <div className="sign-in-bubble">
                <input type="button" value="Reset Password" className="sign-in-button" onClick={this.resetPassword} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    hash: state.password.resetHash,
    toggle: state.modal.clicked,
    resetError: state.password.resetError,
    passwordResetSuccess: state.password.passwordResetSuccess,
    email: state.password.resetEmail,
  }
);

export default connect(mapStateToProps, {
  resetPassword, closeModal, clearPasswordStatuses, clearFullPasswordState, switchModal,
})(ResetPassword);
